import { AttemptOrigin } from '../../../enums'
import type { JsonValue } from '../../../types/json.types'
import { AttemptCapabilities } from '../../../interfaces/attempt-capabilities.interface'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { CursorPaginationResponseDto } from '../../../common/dto/pagination-cursor.dto'
import { UserDetail, UserResponseDto, UserSummaryDto } from '@sphere/user/domain'
import { AttemptStatusResponseDto } from '../../attempt-status/response/attempt-status.response'
import { ActivityTypeRefResponseDto } from '../../activity/response/activity-type-ref.response'

export class AttemptActivityEntity {
  @ApiProperty({ type: 'string' })
  id!: string

  @ApiProperty({ type: 'string' })
  title!: string

  @ApiProperty({ type: 'string' })
  typeId!: string

  @ApiPropertyOptional({ type: 'string', nullable: true })
  description!: string | null

  @ApiProperty({ type: Object })
  content!: JsonValue

  @ApiProperty({ type: Object })
  config!: JsonValue

  @ApiProperty({ type: () => ActivityTypeRefResponseDto })
  type!: ActivityTypeRefResponseDto
}

export class AttemptEntity {
  @ApiProperty({ type: 'string' })
  id!: string

  @ApiProperty({ type: 'string' })
  userId!: string

  @ApiProperty({ type: () => UserResponseDto })
  user!: UserDetail

  @ApiProperty({ type: 'string' })
  activityId!: string

  @ApiPropertyOptional({ type: 'string', nullable: true })
  lessonId!: string | null

  @ApiPropertyOptional({ type: 'string', format: 'uuid', description: "ID de l'enseignement", nullable: true })
  teachingId!: string | null

  @ApiPropertyOptional({ type: 'string', nullable: true })
  classId!: string | null

  @ApiPropertyOptional({ type: 'string', nullable: true })
  establishmentId!: string | null

  @ApiProperty({ enum: AttemptOrigin })
  origin!: AttemptOrigin

  @ApiPropertyOptional({ type: 'string', nullable: true })
  originRefId!: string | null

  @ApiProperty({ type: 'string' })
  statusId!: string

  @ApiProperty({ type: Number })
  attemptNo!: number

  @ApiProperty({ type: 'string', format: 'date-time' })
  startedAt!: Date

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  submittedAt!: Date | null

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  gradedAt!: Date | null

  @ApiPropertyOptional({ type: Number, nullable: true })
  score!: number | null

  @ApiPropertyOptional({ type: Number, nullable: true })
  maxScore!: number | null

  @ApiPropertyOptional({ type: Boolean, nullable: true })
  passed!: boolean | null

  @ApiPropertyOptional({ type: Number, nullable: true })
  durationSec!: number | null

  @ApiProperty({ type: Object })
  userAnswers!: JsonValue

  @ApiPropertyOptional({ type: Object, nullable: true })
  grading!: JsonValue | null

  @ApiPropertyOptional({ type: Object, nullable: true })
  feedback!: JsonValue | null

  @ApiProperty({ type: Object })
  metadata!: JsonValue

  @ApiPropertyOptional({ type: Object, nullable: true })
  competencyScores!: JsonValue | null

  @ApiProperty({ type: 'string', format: 'date-time' })
  createdAt!: Date

  @ApiProperty({ type: 'string', format: 'date-time' })
  updatedAt!: Date

  @ApiProperty({ type: () => AttemptStatusResponseDto })
  status!: AttemptStatusResponseDto

  @ApiProperty({ type: () => AttemptActivityEntity })
  activity!: AttemptActivityEntity

  @ApiProperty({
    description: 'Fine-grained permissions for current user',
    type: 'object',
    properties: {
      canView: { type: 'boolean' },
      canEdit: { type: 'boolean' },
      canSubmit: { type: 'boolean' },
      canGrade: { type: 'boolean' },
      canDelete: { type: 'boolean' },
      canViewAnalytics: { type: 'boolean' },
    },
  })
  capabilities!: AttemptCapabilities
}

export class AttemptListResponseDto extends CursorPaginationResponseDto<AttemptEntity> {
  @ApiProperty({ type: () => AttemptEntity, isArray: true })
  declare data: AttemptEntity[]
}
